import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { HelpLink } from '@bingads-webui-react/help-link';
import { Callout } from './callout';
import { getStyles } from './getStyles';
import { CalloutTitle } from './callout-title';

const CalloutWithActionsUnthemed = React.memo(({
  titleProps,
  helpLink,
  linkPlaceholder,
  actions,
  title,
  content,
  classes,
  ...props
}) => {
  const footerClass = useMemo(
    () => classNames(
      'callout-footer',
      classes.calloutFooter,
      actions.length > 0 && classes.actions
    ),
    [actions.length, classes]
  );

  const helpLinkComponent = linkPlaceholder
    || (helpLink && <HelpLink query={helpLink.query}>{helpLink.text}</HelpLink>);

  const footer = useMemo(() => (
    <div className={footerClass}>
      {
        actions.length > 0 && (
          <div className={classNames(classes.footerActionList, 'callout-action-list')}>{actions}</div>
        )
      }
      {
        helpLinkComponent && (
          <div className="callout-action-help-link">{helpLinkComponent}</div>
        )
      }
    </div>
  ), [actions, classes.footerActionList, footerClass, helpLinkComponent]);

  return (
    <Callout
      title={titleProps ? <CalloutTitle {...titleProps} /> : title}
      content={(
        <React.Fragment>
          {content}
          {footer}
        </React.Fragment>
      )}
      {...props}
    />
  );
});

CalloutWithActionsUnthemed.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.string.isRequired,
  ]),
  titleProps: PropTypes.shape({
    iconName: PropTypes.string,
    iconColor: PropTypes.string,
    text: PropTypes.string,
  }),
  content: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.string.isRequired,
  ]),
  helpLink: PropTypes.shape({
    query: PropTypes.string,
    text: PropTypes.string,
  }),
  linkPlaceholder: PropTypes.node,
  actions: PropTypes.arrayOf(PropTypes.node),
  classes: PropTypes.shape({}),
};

CalloutWithActionsUnthemed.defaultProps = {
  title: undefined,
  titleProps: null,
  content: null,
  helpLink: null,
  linkPlaceholder: null,
  actions: [],
  classes: {},
};

export const CalloutWithActions = withDefaultStyles(CalloutWithActionsUnthemed, getStyles);
